// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 783 ? "object-storage-azure" : chunkId) + "." + {"125":"3a3b0989","212":"7c9c5784","278":"ad4e7ddd","779":"7f868b73","783":"9090770b","868":"9c91bbe8"}[chunkId] + ".chunk.js";
};